import { put, takeLatest } from 'redux-saga/effects';
import { FetchStatus } from 'data/core';
import { saveNormalizedPartialTasks } from 'data/tasks/slice';
import { logger } from 'services';
import { saveHomeResponseSagaAction } from '../actions';
import { homeNormalizer } from '../schema';
import { saveHomeResponse, fetchHomeResponseError } from '../slice';
function* saveHomeResponseSaga({ payload }) {
    const response = payload;
    try {
        const normalizedResponse = homeNormalizer(response);
        const { entities: { tasks } } = normalizedResponse;
        yield put(saveNormalizedPartialTasks(tasks));
        yield put(saveHomeResponse({
            data: normalizedResponse,
            fetchStatus: FetchStatus.Loaded
        }));
    } catch (error) {
        logger.error('Unable to store home tasks', {
            error
        });
        yield put(fetchHomeResponseError());
    }
}
export const watchSaveHomeResponseSaga = function*() {
    yield takeLatest(saveHomeResponseSagaAction.type, saveHomeResponseSaga);
};
